import React, { Component } from 'react'
import SimpleDataTable from '../../../../../../modules/SimpleDataTable'
import { configReportAppointmentOverdue } from '../config'
import * as R from 'ramda'
import { fetchDataAsync } from '../../../../../../Services/Utils';
import Api from '../../../../../../Services/Api';
import { HttpStatus } from '../../../../../common/Constants';
export default class ReportAppointmentOverdue extends Component {
  constructor(props){
      super(props);
      this.state = {
        dataTable: [],
      };
    }
  
    componentDidUpdate(prevProps, prevState) {
      if(this.props.doSearch && !R.equals(prevProps.doSearch,this.props.doSearch)){
        this.fetchData()
      }
    } 
  
    fetchData = async () =>{
      try {
        this.props.triggerLoading();
        const res = await fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanAppointmentOverdue,
          setError: this.props.setError,
          menuName: "Dashboard CRM Koordinator - Statistik Hari Ini",
          args: {
            kodeCabang: this.props.search.kodeCabang,
            teamLeaderEmployeeId: this.props.search?.teamLeader || null
          },
        });
        this.props.onSuccessSearch()
        this.props.triggerLoading();
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
          this.setState((prev) => ({
            ...prev,
            dataTable: res.data.data,
          }));
        }
      } catch (e) {
        this.props.onSuccessSearch()
        this.props.triggerLoading();
        console.log(e);
      }
    }
  render() {
    return (
      <div style={{ padding: "10px", gap: "20px" }}>
        <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
          LAPORAN APPOINTMENT OVERDUE
        </p>
        <SimpleDataTable
          data={this.state.dataTable}
          columns={configReportAppointmentOverdue}
          rowsPerPage={5}
          page={0}
          options={{serverSide: false}}
        />
      </div>
    );
  }
}
